import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const handSignWidth = 96;
export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: calc(100% - 60px - 65px);
    width: ${1280 - handSignWidth}px;
    ${p => p.isEaster && css`
        margin-top: 115px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 66px;
        width: 996px;
        height: calc(100% - 60px - 115px - 62px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 340px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 64px;
    left: -6px;
    right: 74px;
    bottom: 68px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${115 - padding}px;
    left: ${116 - padding}px;
    right: ${168 - padding}px;
    bottom: ${123 - padding}px;
    z-index: -1;
`;

export const HandSignLadderWrapper = styled.div<IStyleProps>`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;

    ${p =>
        p.isLow
            ? css`
                  right: 164px;
              `
            : undefined}

    &.Completed {
        opacity: 0.4;
        pointer-events: none;
        transition: 2s;
    }
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;

    img {
        width: 1280px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    top: 79px;
    left: 235px;
    pointer-events: none;
    img {
        width: 85px;
    }
`;

export const Asset3Wrapper = styled.div`
    position: absolute;
    top: 96px;
    right: 257px;
    pointer-events: none;
    img {
        width: 53px;
    }
`;

const handSignButton = css`
    position: absolute;
    right: ${handSignWidth}px;
    padding: 12px;
    border: none;
    margin: 0;
    background-color: transparent;
    cursor: pointer;
    outline: none;
    span {
        font-size: 50px;
        color: ${p => p.theme.c.black};
        display: inline-block;
    }

    &.active span {
        color: ${p => p.theme.c.boost};
    }
`;

export const HandSignSharpButton = styled.button`
    ${handSignButton}
    top: 0;
`;

export const HandSignFlatButton = styled.button`
    ${handSignButton}
    .i-arrowup {
        transform: rotate(180deg);
    }
    bottom: 0;
`;
